var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMessageAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.04 22.03-4.26-2.84H8.89c-.23 0-.45-.11-.59-.29a.763.763 0 0 1-.13-.65 3 3 0 0 0 .09-.74c0-.8-.3-1.57-.84-2.17a3.2 3.2 0 0 0-2.41-1.08c-.89 0-1.72.35-2.33.98-.19.2-.48.28-.74.2a.77.77 0 0 1-.53-.56c-.1-.44-.15-.92-.15-1.44v-6c0-3.44 2.31-5.75 5.75-5.75h10c3.44 0 5.75 2.31 5.75 5.75v6c0 1.67-.55 3.11-1.6 4.16-.88.88-2.05 1.41-3.4 1.55v1.42c0 .65-.36 1.24-.93 1.55-.27.13-.55.2-.83.2-.34 0-.67-.1-.96-.29zM11 17.68c.15 0 .29.04.42.13l4.45 2.97c.1.07.2.04.25.01.05-.03.14-.09.14-.23v-2.13c0-.41.34-.75.75-.75 1.27 0 2.34-.4 3.09-1.15.76-.76 1.16-1.83 1.16-3.1v-6c0-2.58-1.67-4.25-4.25-4.25h-10c-2.58 0-4.25 1.67-4.25 4.25v5.88a4.69 4.69 0 0 1 2.25-.56c1.36 0 2.65.58 3.53 1.58.78.87 1.22 2 1.22 3.17-.01.06-.01.12-.01.18H11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83 21.02c-.35-.3-.66-.67-.9-1.08-.44-.72-.68-1.57-.68-2.44 0-1.25.48-2.42 1.34-3.31.9-.93 2.11-1.44 3.41-1.44 1.36 0 2.65.58 3.53 1.58.78.87 1.22 2 1.22 3.17 0 .38-.05.76-.15 1.12-.1.45-.29.92-.55 1.33-.83 1.42-2.39 2.3-4.05 2.3a4.7 4.7 0 0 1-3.17-1.23zm.84-5.79a3.241 3.241 0 0 0-.45 3.94c.16.28.37.53.61.74a3.222 3.222 0 0 0 4.95-.72c.18-.28.3-.59.37-.91.07-.26.1-.51.1-.77 0-.8-.3-1.57-.84-2.17-.6-.7-1.48-1.09-2.41-1.09-.89 0-1.72.35-2.33.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18.23c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.99a.749.749 0 1 1 0 1.5H3.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 19.01v-2.99c0-.41.34-.75.75-.75s.75.34.75.75v2.99a.749.749 0 1 1-1.5 0zM8.5 11.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75h-7z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMessageAdd);
export default __webpack_public_path__ + "static/media/vuesax-outline-message-add.49b36f72d13b261a0ac10694382af563.svg";
export { ForwardRef as ReactComponent };